import "./login.css"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import useSignIn from 'react-auth-kit/hooks/useSignIn';
import { handleLogin } from "../../requests/userRequests";
import { useGlobalContext } from "../../context";
import { Link } from "react-router-dom";


function Login() {
    const navigate = useNavigate()
    const signIn = useSignIn()

    const {handleErr} = useGlobalContext()
    const [user, setUser] = useState({
        phoneNumber: "",
        password: ""
    })
    console.log(user)
    const handleLoginForm = async (e) => {
        e.preventDefault()
        try {
            const res = await handleLogin(user)
            if(res.type == "error"){
                return handleErr(res.type , res.massage)
            }
            console.log(res)
            signIn({
                auth: {
                    token: res.token
                },
                userState: {
                    phoneNumber: res.phoneNumber,
                    username: res.username,
                    _id: res._id,
                    admin: res.admin
                }
            })
            navigate("/")
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <div className="login">
            <div className="login-container">
                <div className="grid">
                    <form onSubmit={(e) => handleLoginForm(e)} className="form login">
                        <div className="form__field">
                            <input onChange={(e) => setUser({ ...user, phoneNumber: e.target.value })} id="login__password" type="text" name="phoneNumber" className="form__input" placeholder="شماره تلفن" required />
                        </div>

                        <div className="form__field">
                            <input onChange={(e) => setUser({ ...user, password: e.target.value })} id="login__password" type="password" name="password" className="form__input" placeholder="رمز" required />
                        </div>

                        <div className="form__field">
                            <input type="submit" value="ورود"/>
                        </div>
                        <Link to={"/register"}>ثبت نام</Link>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default Login;